import { apiCall } from './gqlClient';

const ATHLETEASSESSMENTS_QUERY = `
  query athleteAssessments($athleteProfileId: String!) {
    athleteAssessments(athleteProfileId: $athleteProfileId)
    {
      id
			athleteProfileId
			assessedAt
			discipline
			metrics
			schemaVersion
			notes
			createdAt
      ...fragments
    }
  }`;

export const athleteAssessmentsApiCall = async ({athleteProfileId}, fragments = null) => apiCall({ query: ATHLETEASSESSMENTS_QUERY, variables: {athleteProfileId}, fragments });

const CREATEATHLETEASSESSMENT_QUERY = `
  mutation createAthleteAssessment($input: AthleteAssessmentInput!) {
    createAthleteAssessment(input: $input)
    {
      id
			athleteProfileId
			assessedAt
			discipline
			metrics
			schemaVersion
			notes
			createdAt
      ...fragments
    }
  }`;

export const createAthleteAssessmentApiCall = async ({input}, fragments = null) => apiCall({ query: CREATEATHLETEASSESSMENT_QUERY, variables: {input}, fragments });

const UPDATEATHLETEASSESSMENT_QUERY = `
  mutation updateAthleteAssessment($id: String!, $input: AthleteAssessmentInput!) {
    updateAthleteAssessment(id: $id, input: $input)
    {
      id
			athleteProfileId
			assessedAt
			discipline
			metrics
			schemaVersion
			notes
			createdAt
      ...fragments
    }
  }`;

export const updateAthleteAssessmentApiCall = async ({id, input}, fragments = null) => apiCall({ query: UPDATEATHLETEASSESSMENT_QUERY, variables: {id, input}, fragments });

const DELETEATHLETEASSESSMENT_QUERY = `
  mutation deleteAthleteAssessment($id: String!) {
    deleteAthleteAssessment(id: $id)
    {
      id
			athleteProfileId
			assessedAt
			discipline
			metrics
			schemaVersion
			notes
			createdAt
      ...fragments
    }
  }`;

export const deleteAthleteAssessmentApiCall = async ({id}, fragments = null) => apiCall({ query: DELETEATHLETEASSESSMENT_QUERY, variables: {id}, fragments });
